import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorState } from "@/components/error-state";
import { newCorrelationId } from "@/lib/correlation";

interface State { error: Error | null; correlationId: string; }

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null, correlationId: "" };

  static getDerivedStateFromError(error: Error): State {
    return { error, correlationId: newCorrelationId() };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // App Insights wiring lives in a later plan; for now log to console.
    console.error("AppErrorBoundary", { error, info, correlationId: this.state.correlationId });
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorState
          message={this.state.error.message}
          correlationId={this.state.correlationId}
          onRetry={() => this.setState({ error: null, correlationId: "" })}
        />
      );
    }
    return this.props.children;
  }
}
